import { ReactNode, useMemo } from 'react'

import { Link, matchPath } from 'react-router-dom'

import { useI18n } from '@tribeplatform/react-components/i18n'
import { useRouterPath } from '@tribeplatform/react-sdk'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Container } from '@tribeplatform/react-ui-kit/Layout'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

export const MessagingSettingsLayout = ({
  children,
}: {
  children: ReactNode
}) => {
  const pathname = useRouterPath()
  const { $t } = useI18n()
  const items = useMemo(() => {
    return [
      {
        text: $t({
          defaultMessage: 'All messages',
          id: 'Messaging.Settings.Back',
        }),
        link: '/messaging',
        icon: <SvgIcon className="rtl:-scale-x-100" name="arrow-left" />,
      },
      {
        text: $t({
          defaultMessage: 'Blocked',
          id: 'Generics.Blocked',
        }),
        link: '/messaging/settings/blocked',
        icon: <SvgIcon name="hand" />,
      },
      {
        text: $t({
          defaultMessage: 'Settings',
          id: 'Generics.Settings',
        }),
        link: '/messaging/settings',
        icon: <SvgIcon name="settings" />,
      },
    ]
  }, [$t])

  const activeItem = useMemo(() => {
    return items.find(item =>
      matchPath(
        {
          path: item.link,
          end: true,
          caseSensitive: true,
        },
        pathname,
      ),
    )
  }, [items, pathname])

  return (
    <Container
      size="full"
      padding={{
        vertical: 'md',
        horizontal: { size: 'md', disableOnMobile: true },
      }}
    >
      <Container size="xl" direction="grid">
        <Container size="sm" padding={{ size: 'md', onlyOnMobile: true }}>
          <NavVertical>
            <NavVertical.Group>
              {items.map(item => (
                <NavVertical.Item
                  key={item.link}
                  active={activeItem?.link === item.link}
                  as={Link}
                  leadingIcon={item.icon}
                  to={item.link}
                >
                  {item.text}
                </NavVertical.Item>
              ))}
            </NavVertical.Group>
          </NavVertical>
        </Container>
        <Container size="md">{children}</Container>
      </Container>
    </Container>
  )
}
